module.exports = __webpack_public_path__ + "img/usa-diabetes-mellitus-male.ec75044d.png";